export default "__VITE_ASSET__D91dZ61h__"